import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onActivated, ref, nextTick } from 'vue'
import Pagination from '../../../components/Pagination.vue'
import { getPackageListApi } from '../../../apis/coupon-saas'
import { CouponType } from '../enum'
import PackageDialog from './PackageDialog.vue'
import InDialog from './InDialog.vue'
import OutDialog from './OutDialog.vue'
import { useStore } from '@/store'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import SelectChannel from '@/components/SelectChannel.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const router = useRouter()
const store = useStore()
const user_id = (store.state.user.userInfo.id).toString()
const state = reactive ({
    channel_no:'',
    channel_name:'',
    dialogVisible:          false,  // 弹框是否显示
})
const filters = reactive({
        id: '', 
        name: '',
        brand_name:'',
        amount:'',
        status: '', 
        type:'', 
        page: 1,
        page_size: 10,
})
const out = (type) => {
    window.open(`${Keys.baseUrl}/coupon/offline_coupon/getOfflineCouponList?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&export=${type}`)
}
const toExport = () => {
    const {channel_no,channel_name} = state
    window.open(`${Keys.baseUrl}/coupon/offline_coupon/export_channel_quotation?${joinParams({...filters, user_id: store.state.user.userInfo.id})}&channel_no=${channel_no}&channel_name=${channel_name}`)
    dialogBeforeClose()
}
const dialogBeforeClose = () => {
    state.channel_name = ''
    state.channel_no = ''
    proxy.$refs['selectChannelRef']?.clearVal()
    state.dialogVisible = false
}
const onChannelChange = (val) => {
    state.channel_no = val?.channel_no || ''
    state.channel_name = val?.channel_name || ''
}

// 查看卡号、密码权限（超级管理员、账务、商务）
const userGroups = store.state.user.userInfo.group_id.split(',')
const opAuth = ref(userGroups.includes('1') || userGroups.includes('5') || userGroups.includes('18'))

// 列表数据
const tableData = ref([])
const total = ref(0)
const getList = async () => {
    const { code, data, msg } = await getPackageListApi(filters) as any
    if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
    tableData.value = data.data
    total.value = data.total
}

// 打开操作弹框
const openActionDialog = ({type, outType = 1, coupon_id = '', coupon_name = '', union_ids = [], coupon_status = ''}) => {
    nextTick(() => {
        const actions = ['packageDialog', 'inDialog', 'outDialog']
        proxy.$refs[actions[type]].openDialog({type: outType, coupon_id, coupon_name, union_ids, coupon_status})
    })
}

const search = () => {
    filters.page = 1
    getList()
}
const onPageChange = (val) => {
    filters.page = val
    getList()
}
const onSizeChange = (val) => {
    filters.page_size = val
    getList()
}
onActivated(() => {
    getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.id) = $event)),
        modelModifiers: { trim: true },
        placeholder: "券包ID",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "名称",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.brand_name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.brand_name) = $event)),
        modelModifiers: { trim: true },
        placeholder: "品牌",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.amount,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.amount) = $event)),
        modelModifiers: { trim: true },
        placeholder: "面值",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.status,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.status) = $event)),
        placeholder: "状态",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: 1,
            label: "上架"
          }),
          _createVNode(_component_el_option, {
            value: 0,
            label: "下架"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.type,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filters.type) = $event)),
        placeholder: "类型",
        clearable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            value: 1,
            label: "采购"
          }),
          _createVNode(_component_el_option, {
            value: 2,
            label: "自制"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      (opAuth.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (openActionDialog({type: 0})))
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("添加券包")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (openActionDialog({type: 1})))
            }, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createTextVNode("采购入库")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (out(true)))
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [
                _createTextVNode("导出")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              class: "filter-btn",
              type: "primary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (state.dialogVisible=true))
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode("报价导出")
              ])),
              _: 1
            })
          ], 64))
        : _createCommentVNode("", true),
      (['5086', '5089', '10191'].includes(_unref(user_id)))
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            class: "filter-btn",
            type: "primary",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (out(true)))
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode("导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_link, {
        style: {"float":"right","margin":"25px 10px 0 0","font-size":"14px"},
        type: "primary",
        underline: "",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_unref(router).push('/coupon/expired-list')))
      }, {
        default: _withCtx(() => _cache[20] || (_cache[20] = [
          _createTextVNode("过期券 >>")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "券包ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "supplier_name",
          label: "供应商"
        }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "面值"
        }),
        _createVNode(_component_el_table_column, {
          label: "蛋叔券包ID",
          width: "90"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ds_coupon_ids ? scope.row.ds_coupon_ids.join(",") : "--"), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "ds_product_id",
          label: "商品名称ID"
        }),
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称"
        }),
        _createVNode(_component_el_table_column, {
          prop: "platform_count",
          label: "平台库存"
        }),
        _createVNode(_component_el_table_column, {
          prop: "overall_count",
          label: "总库存/留底数",
          width: "103"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.overall_count) + "/" + _toDisplayString(scope.row.liudi_count), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "average_consume",
          label: "平均日消耗"
        }),
        _createVNode(_component_el_table_column, {
          prop: "yesterday_sum",
          label: "昨日消耗"
        }),
        _createVNode(_component_el_table_column, { label: "消耗增长率" }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", {
              class: _normalizeClass(scope.row.zh_jisuan > 50 ? 'color-danger bold' : '')
            }, _toDisplayString(scope.row.zh_jisuan) + "%", 3)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "all_count",
          label: "合计库存",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          prop: "days",
          label: "可消耗天数"
        }),
        _createVNode(_component_el_table_column, {
          prop: "channel_name",
          label: "类型",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(_unref(CouponType)[scope.row.type]), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "status_text",
          label: "状态",
          width: "70"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "177",
          fixed: "right"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_unref(router).push(`/coupon-iso/coupon-list?coupon_id=${scope.row.id}`))
              }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("查看")
                ])),
                _: 2
              }, 1032, ["onClick"]),
              (opAuth.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      disabled: _unref(CouponType)[scope.row.type] == '自制',
                      title: "自制类券包不允许向平台出库",
                      onClick: ($event: any) => (openActionDialog({type: 2, outType: 1, coupon_id: scope.row.id, coupon_status: scope.row.type, union_ids: scope.row.ds_coupon_ids}))
                    }, {
                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                        _createTextVNode("平台出库")
                      ])),
                      _: 2
                    }, 1032, ["disabled", "onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      style: {"margin-top":"10px"},
                      onClick: ($event: any) => (openActionDialog({type: 0, coupon_id: scope.row.id, coupon_name: scope.row.name, union_ids: scope.row.ds_coupon_ids, coupon_status: scope.row.type}))
                    }, {
                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                        _createTextVNode("关联券包")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      title: "报价导出",
      modelValue: state.dialogVisible,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((state.dialogVisible) = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: dialogBeforeClose }, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [
            _createTextVNode("取 消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: toExport
        }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode("确 定")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(SelectChannel, {
          onChannelChange: onChannelChange,
          ref: "selectChannelRef"
        }, null, 512)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"]),
    _createVNode(PackageDialog, {
      ref: "packageDialog",
      onReloadList: getList
    }, null, 512),
    _createVNode(InDialog, {
      ref: "inDialog",
      onReloadList: getList
    }, null, 512),
    _createVNode(OutDialog, {
      ref: "outDialog",
      onReloadList: getList
    }, null, 512)
  ]))
}
}

})